import React from 'react';

const PageLoading = (): JSX.Element => (
  <div className="hero is-fullheight">
    <div className="hero-body">
      <div className="container has-text-centered">
        <div className="loading-block" />
      </div>
    </div>
  </div>
);

export default PageLoading;
